import "./ExamResult.css";
import React, { Fragment } from "react";
import ExamResultViewModel from "./ExamResultViewModel";
import { PulseLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";

const ExamResult = () => {
  const {
    ExamData,
    ResultData,
    IsLoading,
    UsersData,
    ExamType,
    CourseName,
    componentRef,
    handlePrint,
  } = ExamResultViewModel();

  const navigate = useNavigate();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-view-result-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">View Result</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">Dashboard</a>
                  </li>
                  <li className="breadcrumb-item active">View Result</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="student-group-form">
            <div className="row">
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by ID ..."
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Name ..."
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Year ..."
                  />
                </div>
              </div>
              <div className="col-lg-2">
                <div className="search-student-btn">
                  <button type="btn" className="btn btn-primary">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col result-table-header">
                        <h3 className="page-title">View Result</h3>
                        <button onClick={handlePrint}>Print</button>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div ref={componentRef} className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Name</th>
                            <th>Registration No</th>
                            <th>Exam Type</th>
                            <th>Subject</th>
                            <th>Gender</th>
                            <th className="text-end">Marks Obtained</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {UsersData &&
                            UsersData.map((item, index) => {
                              console.log("item", item);
                              // First Name Start
                              const ArrayOfFirstNameWords =
                                item?.FirstName.split(" ");
                              for (
                                var i = 0;
                                i < ArrayOfFirstNameWords.length;
                                i++
                              ) {
                                ArrayOfFirstNameWords[i] =
                                  ArrayOfFirstNameWords[i]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfFirstNameWords[i].slice(1);
                              }
                              const StringOfFirstNameWords =
                                ArrayOfFirstNameWords.join(" ");
                              // First Name End

                              // Last Name Start
                              const ArrayOfLastNameWords =
                                item?.LastName.split(" ");
                              for (
                                var j = 0;
                                j < ArrayOfLastNameWords.length;
                                j++
                              ) {
                                ArrayOfLastNameWords[j] =
                                  ArrayOfLastNameWords[j]
                                    .charAt(0)
                                    .toUpperCase() +
                                  ArrayOfLastNameWords[j].slice(1);
                              }
                              const StringOfLastNameWords =
                                ArrayOfLastNameWords.join(" ");
                              // Last Name End
                              return (
                                <tr key={index}>
                                  <td>
                                    {StringOfFirstNameWords +
                                      " " +
                                      StringOfLastNameWords}
                                  </td>

                                  <td>
                                    {
                                      item?.AdditionalDetails
                                        ?.StudentRegistrationNo
                                    }
                                  </td>
                                  <td>{ExamType}</td>
                                  <td>{CourseName}</td>

                                  <td className="text-capitalize">
                                    {item?.Gender}
                                  </td>

                                  <td className="text-end">
                                    {
                                      ResultData?.StudentsMarks[index]
                                        ?.ObtainedMarks
                                    }
                                    /{ExamData?.ExamTotalMarks}
                                  </td>
                                  <td className="text-end">
                                    <button
                                      className="view-single-exam-btn"
                                      onClick={() => {
                                        navigate(
                                          "/user/admin/classes/user-result",
                                          {
                                            state: {
                                              user: {
                                                name:
                                                  item.FirstName +
                                                  " " +
                                                  item.LastName,
                                                gender: item.Gender,
                                                regNo:
                                                  item?.AdditionalDetails
                                                    ?.StudentRegistrationNo,
                                                ClassId:
                                                  item?.AdditionalDetails
                                                    ?.ClassID,
                                                CourseName: CourseName,
                                                image: item?.photoURL,
                                                ExamType: ExamType,
                                                ObtainedMarks:
                                                  ResultData?.StudentsMarks[
                                                    index
                                                  ]?.ObtainedMarks,
                                                ExamTotalMarks:
                                                  ExamData?.ExamTotalMarks,
                                              },
                                            },
                                          }
                                        );
                                      }}
                                    >
                                      View
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>

                {/* <div className="col-auto text-end float-end ms-auto download-grp submit-btn-container">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      RegisterResult();
                    }}
                    // disabled={FormDisabled}
                  >
                    Save
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default ExamResult;
